export class CountryUrlExtensionConstants {
    public static PDF = 'pdf';
    public static LEGACY = 'legacy';
    public static CONTACT_FOREVERE_LIVING = 'contact-forever-living';
    public static EXTERNAL = 'external';
    public static SHOP = 'shop';
}
